import { useLocation } from "react-router";
import { KybUpload, KybReviewing, KybRejected } from "../../icons";
import { Link } from "react-router";

const KybStatusPage = () => {
  const location = useLocation();
  const kybStatus = location.state?.kybStatus || "PENDING";

  const getStatusContent = (status: string) => {
    switch (status) {
      case "REVIEWING":
        return {
          title: "Your KYB Verification is Being Reviewed",
          message:
            "We’ve received your KYB submission and it's currently under review. You’ll be notified once a decision is made.",
          Icon: KybReviewing,
        };
      case "REJECTED":
        return {
          title: "Your KYB Verification Was Rejected",
          message:
            "Unfortunately, your KYB verification was rejected. Please check your details and resubmit your application. or contact compliance@monirates.com",
          Icon: KybRejected,
        };
      default:
        return {
          title: "Begin Your KYB Verification",
          message:
            "To access your dashboard and start using our services, you need to complete your KYB verification. It only takes a few minutes.",
          Icon: KybUpload,
        };
    }
  };

  const { title, message, Icon } = getStatusContent(kybStatus);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center bg-gray-50">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-6">
          <Icon className="w-32 h-32" />
        </div>

        <h1 className="text-2xl font-semibold text-gray-800 mb-2">{title}</h1>
        <p className="text-gray-600 mb-6">{message}</p>

        <p className="text-sm text-gray-700">
          {kybStatus === "REJECTED"
            ? "Need to fix or resubmit your KYB? " : kybStatus === "PENDING" ? "Upload your kyb document/information "
            : "Haven't completed your KYB information? "}
          <Link
            to="https://onboarding.monirates.com"
            className="text-brand-600 hover:underline font-medium"
            target="_blank"
          >
            Click here.
          </Link>
        </p>
      </div>
    </div>
  );
};

export default KybStatusPage;